import type { StreamDisconnectReason } from '@injectivelabs/sdk-ts/types/light'

export interface StreamHandlers<TResponse = any> {
  onData: (response: TResponse) => void
  onError?: (payload: { details?: any; message: string }) => void
  onConnect?: (payload: { attempt: number; isReconnect: boolean }) => void
  onRetry?: (payload: {
    attempt: number
    delayMs: number
    nextBackoff: null | number
  }) => void
  onDisconnect?: (payload: {
    attempt?: number
    willRetry: boolean
    reason: StreamDisconnectReason
  }) => void
}

export enum StreamKey {
  // Infrastructure (always enabled, cannot be toggled off)
  Infrastructure = 'infrastructure',
  BlockHeight = 'block-height',

  // Core streams (default: enabled)
  Orderbook = 'orderbook',
  MarkPrices = 'mark-prices',
  IndexPrices = 'index-prices',

  // Derivative streams (default: disabled)
  DerivativeTrades = 'derivative-trades',
  DerivativeOrders = 'derivative-orders',
  DerivativeOrderHistory = 'derivative-order-history',
  DerivativeTradesSubaccount = 'derivative-trades-subaccount',

  // TC Derivative streams (default: disabled)
  TcDerivativeTrades = 'tc-derivative-trades',
  TcDerivativeOrders = 'tc-derivative-orders',
  TcDerivativePositions = 'tc-derivative-positions',
  TcDerivativeOrderHistory = 'tc-derivative-order-history',

  // Account streams (default: disabled)
  Positions = 'positions',
  BankBalance = 'bank-balance',
  SubaccountBalance = 'subaccount-balance'
}

export enum StreamLogType {
  Error = 'error',
  Warn = 'warn',
  Log = 'log'
}
